import React from 'react';
import {object} from 'prop-types';

import { formatFootage } from '../../utils/number-util';
import { formatUOMLabel } from '../../utils/format-utils';

import classes from './PanelInsert.module.css';

const AreaItemPanelInsert = ({node}) => {
    return (
        <dl className={classes.agentInfo}>
            <dt>Name</dt>
            <dd>{node.name}</dd>

            <dt>Area</dt>
            <dd>{formatFootage(node.squareFootage) + ' ' + formatUOMLabel(node.squareAreaUOM)}</dd>
        </dl>
    );
};

AreaItemPanelInsert.defaultProps = {
    node: {}
};

AreaItemPanelInsert.propTypes = {
    node: object.isRequired
};

export default AreaItemPanelInsert;
